import { useCallback } from 'react'
import { useBulkActionContext } from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { updateLoadingState } from '@sales-center/common'
import {
  BulkUpdateExpectedClosingDateFormModel,
  SubmitCallback,
} from '../typings'
import { toast } from '@sales-center/components'

export const useFormActions = (submitCallback: SubmitCallback) => {
  const appDispatch = useAppDispatch()
  const { selectedRows, dispatch } = useBulkActionContext()

  const onSubmit = useCallback(
    async ({ expectedClosingDate }: BulkUpdateExpectedClosingDateFormModel) => {
      try {
        appDispatch(updateLoadingState('visible'))
        await submitCallback({
          expectedClosingDate,
          ids: selectedRows.map((id) => Number(id)),
        })
        dispatch({ type: 'setActive' })
      } finally {
        appDispatch(updateLoadingState('hidden'))
        toast.success('Bulk update successfully applied')
      }
    },
    [appDispatch, dispatch, submitCallback, selectedRows],
  )

  return onSubmit
}
